/**
 * Hook to share local filtering capability for value and mapping tables
 */
import { useCallback } from 'react';

export interface FilterableCollection {
  filter: (term: string) => void;
}

interface Props {
  collection?: FilterableCollection | null;
}

function useCollectionFiltering(props: Props) {
  const { collection } = props;

  const onSearch = useCallback(
    (term: string) => {
      if (collection) {
        collection.filter(term);
      }
    },
    [collection]
  );

  return { onSearch };
}

export default useCollectionFiltering;
